const signup = async (user) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/register`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      }
    );
    return await res.json();
  } catch (err) {
    console.log(err);
  }
};

const login = async (user) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}` + "/api/users/login",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      }
    );
    return await res.json();
  } catch (err) {
    console.log(err);
  }
};

const getUser = async (params) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}` + "/api/users/" + params.id
    );
    return res.json();
  } catch (err) {
    console.log(err);
  }
};

const getRandomUsers = async (query) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}` +
        "/api/users/random?" +
        new URLSearchParams(query)
    );
    return res.json();
  } catch (err) {
    console.log(err);
  }
};

export { signup, login, getUser, getRandomUsers };
